import React, { useEffect, useState, useContext } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";
import jsPDF from "./jspdf";
import "../styles/UserTracking.css";
import { AuthContext } from "../App"; // ✅ Context import

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const UserTracking = () => {
  const { profileData } = useContext(AuthContext); // ✅ Use profile data dynamically

  const [currentUsage, setCurrentUsage] = useState(0);
  const [alerts, setAlerts] = useState([]);
  const [viewMode, setViewMode] = useState("daily");
  const [dailyData, setDailyData] = useState([120, 130, 140, 150, 160, 180, 200]);
  const [weeklyData, setWeeklyData] = useState([800, 1020, 890, 960]);

  const name = profileData?.name || "Varun Deshmukh";
  const userType = profileData?.userType || "Residential";
  const area = profileData?.area || "Wakad";

  useEffect(() => {
    const interval = setInterval(() => {
      const randomIncrement = Math.floor(Math.random() * 5 + 1);
      setCurrentUsage((prev) => {
        const newUsage = prev + randomIncrement;
        if (newUsage > 250 && !alerts.length) {
          setAlerts([{ id: 1, message: "⚠️ Possible leak detected!" }]);
        }
        return newUsage;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, [alerts]);

  const downloadReport = () => {
    const doc = new jsPDF();
    doc.text("Water Usage Report", 20, 20);
    doc.text(`Total: ${currentUsage} Liters`, 20, 40);
    doc.save("Usage_Report.pdf");
  };

  const barChartData = {
    labels: viewMode === "daily" ? ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] : ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: viewMode === "daily" ? "Daily Water Usage (L)" : "Weekly Water Usage (L)",
        data: viewMode === "daily" ? dailyData : weeklyData,
        backgroundColor: "#007bff",
        borderRadius: 8,
      },
    ],
  };

  return (
    <div className="tracking-wrapper">
      <h2>💧 User Water Tracking Dashboard</h2>

      <div className="user-info">
        <p>👤 User: <strong>{name}</strong></p>
        <p>🏘️ Area: <strong>{area}</strong></p>
        <p>🏠 Type: <strong>{userType}</strong></p>
      </div>

      <div className="live-usage-card">
        <h3>🚰 Live Usage</h3>
        <p>{currentUsage} Liters</p>
      </div>

      <div className="summary-cards">
        <div className="card">Today: {currentUsage} L</div>
        <div className="card">Weekly: ~1020 L</div>
        <div className="card">Monthly: ~4200 L</div>
      </div>

      <div className="toggle-buttons">
        <button className={viewMode === "daily" ? "active" : ""} onClick={() => setViewMode("daily")}>Daily</button>
        <button className={viewMode === "weekly" ? "active" : ""} onClick={() => setViewMode("weekly")}>Weekly</button>
      </div>

      <div className="chart-section">
        <h3>📊 Usage {viewMode === "daily" ? "This Week" : "Over 4 Weeks"}</h3>
        <Bar data={barChartData} />
      </div>

      <div className="alerts-section">
        <h3>🚨 Alerts</h3>
        {alerts.length ? (
          alerts.map((alert) => <p key={alert.id}>{alert.message}</p>)
        ) : (
          <p>✅ No alerts</p>
        )}
      </div>

      <button className="export-btn" onClick={downloadReport}>🧾 Download Report</button>
    </div>
  );
};

export default UserTracking;
